import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import parse from 'html-react-parser';
import { Link } from 'react-router';

import { GetPackagesResult } from 'api/hooks/public/useGetPackages';

interface PropTypes {
  package?: GetPackagesResult;
}

function PackageInfo(props: PropTypes): JSX.Element {
  return (
    <Box>
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        flexDirection={{ xs: 'column', sm: 'row' }}
      >
        <Box>
          <Typography fontWeight={700} variant={'h4'} gutterBottom>
            {props.package?.title ?? <Skeleton width={300} />}
          </Typography>

          {/* {props.package?.locations.map((location) => {
            return (
              <Typography variant={'h6'} key={location.id}>
                <strong>{location.name}:</strong> {location.remCapacity}

              </Typography>
            );
          }) ??
            <>
              <Skeleton width={200} />
              <Skeleton width={200} />
            </>} */}
        </Box>
        <Box display="flex" marginTop={{ xs: 2, md: 0 }} flexShrink={0} width={{ xs: 1, sm: 'unset' }}>
          {/* <Button
            variant="contained"
            color="primary"
            size="large"
          >
            <strong>Register Now</strong>
          </Button> */}

          <Button
            component={Link}
            to="/#packages"
            variant="outlined"
            color="primary"
            size="large"
            fullWidth
            endIcon={
              <Box
                component={'svg'}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                width={24}
                height={24}
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </Box>
            }
            // sx={{ marginLeft: 2 }}
          >
            View All Packages
          </Button>
        </Box>
      </Box>

      <Divider sx={{ marginY: 4 }} />

      <Box marginBottom={3}>{props.package?.description && parse(props.package.description)}</Box>
    </Box>
  );
}

export default PackageInfo;
